import React from 'react';
import moment from 'moment'; // import moment from 'hell';
import FormSection from './FormSection.js';
import {Col, Row} from 'reactstrap';

/* Poor Man's PropTypes:
{
	activeID: id,
	activeIDKey: "activeMod" || "activeSvc",
	activeType: "quote" || "record",
	activeTypeKey: "activeModType" || "activeSvcType",
	buildRecordForm: buildModRecordForm() || buildSvcRecordForm()
	buildQuoteForm: buildModQuoteForm() || buildSvcQuoteForm(),
	newRecordFromQuote: newModQuoteFromRecord() || false;
	newRecord: createNewModRecord() || createNewSvcRecord(),
	newQuote: createNewModQuote() || createNewSvcQuote(),
	mixedArray: [{<quote>}, {<record>}],
	flavor: "svc" || "mod",
	setNewActiveRecord: (dataObj = { <correctLabel>: id, <correctLabel>: type }) => { this.setState(dataObj) }
}
*/

const QuoteRecordSelector = ({...props}) => {
	console.log('HERE');
	console.log(props);
	if (
		!props.mixedArray ||
		!props.mixedArray.length ||
		props.mixedArray.length <= 0
	) {
		return (
			<div className="recordsContainer">
				<div className="recordsByDate">
					<div className="newRecord recordBtn" onClick={(e) => {
						return props.newRecord(e);
					}}>New Record</div>
					<div className="newQuote recordBtn" onClick={(e) => {
						return props.newQuote(e);
					}}>New Quote</div>
				</div>
				<Row className="activeRecord ml-5 mr-0">
					<Row className="lpad-row">No {props.flavor} records found.</Row>
				</Row>
			</div>
		);
	}

	let elmObj = prepareMixedArray(props);
	let buttons, form = '';
	if (
		elmObj.buttons &&
		elmObj.buttons.length &&
		elmObj.buttons.length > 0
	) {
		buttons = elmObj.buttons;
	}

	if (elmObj.form) {
		form = elmObj.form;
	}

	console.log(elmObj);

	return (
		<div className="recordsContainer">
			<div className="recordsByDate">
				<div className="newRecord recordBtn" onClick={(e) => {
					return props.newRecord(e);
				}}>New Record</div>
				<div className="newQuote recordBtn" onClick={(e) => {
					return props.newQuote(e);
				}}>New Quote</div>
				{buttons}
			</div>
			<Row className="activeRecord ml-5 mr-0">
				<Row className="lpad-row">{form}</Row>
			</Row>
		</div>
	);
};

const prepareMixedArray = ({...props}) => {
	let elmObj = {};
	elmObj.buttons = [];
	elmObj.form = <div />;
	let quoteCounter = 0;
	props.mixedArray.forEach((entry) => {
		if (typeof entry.call_date === 'undefined') {
			quoteCounter++;
		}
	});

	props.mixedArray.forEach((entry, i) => {
		let btnClassName = 'recordBtn';
		if (typeof entry.call_date !== 'undefined') {
			// handle record
			if (
				entry.ID === props.activeID &&
				props.activeType === 'record'
			) {
				btnClassName = 'recordBtn activeBtn';
				elmObj.form = props.buildRecordForm(entry);
			}

			let displayDate = moment(entry.call_date).format('MM.DD.YY');
			elmObj.buttons.push(
				<div
					key={`${props.flavor}-${i}`}
					className={btnClassName}
					onClick={(e) => {
						e.preventDefault();
						let stateObj = {};
						stateObj[props.activeTypeKey] = 'record';
						stateObj[props.activeIDKey] = entry.ID;
						props.setNewActiveRecord(stateObj);
					}}
				>
					{displayDate}
				</div>
			);
		} else {
			// handle quote
			if (
				entry.ID === props.activeID &&
				props.activeType === 'quote'
			) {
				btnClassName = 'recordBtn activeBtn';
				elmObj.form = props.buildQuoteForm(entry);
			}

			let displayString = `Quote #${quoteCounter}`;
			quoteCounter--;
			elmObj.buttons.push(
				<div
					key={`${props.flavor}-${i}`}
					className={btnClassName}
					onClick={(e) => {
						e.preventDefault();
						let stateObj = {};
						stateObj[props.activeTypeKey] = 'quote';
						stateObj[props.activeIDKey] = entry.ID;
						props.setNewActiveRecord(stateObj);
					}}
				>
					{displayString}
				</div>
			);
		}
	});

	return elmObj;
};

export default QuoteRecordSelector;



// WEBPACK FOOTER //
// ./src/components/QuoteRecordSelector.js